/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux/~/symbol-observable/index.js
 ** module id = 509
 ** module chunks = 0
 **/